import { getDefaultLogo } from '@weareopenr/component-library';

export const getLogo = (url: string | null, name: string): string => {
  return url ? url : getDefaultLogo(name);
};
